import React from "react";

const SaveButton = ({ doSave }) => {
  return (
    <a
      className="btn btn-secondary btn-sm btn-success"
      onClick={doSave}
      title={`${window.i18n.t("source_menu.icon_popovers.save")}`}
    >
      <i className="bi bi-floppy" />
    </a>
  );
};

export default SaveButton;
